import useModuleFilters from '../../../shared/data/useModuleFilters';
import FilterBar from '../../../shared/components/patterns/FilterBar';
import { repositorySchema } from '../adminFilter.schemas';
import { useEffect, useMemo, useState } from 'react';
import { listAdminTenants } from '@/modules/admin/services/admin-tenants.service';

const MODULES = [
  ['dashboard', 'Dashboard', 'Core'],
  ['deals', 'Deals', 'Sales'],
  ['clients', 'Clients', 'CRM'],
  ['suppliers', 'Suppliers', 'Procurement'],
  ['staff', 'Staff', 'Operations'],
  ['calendar', 'Calendar', 'Scheduling'],
  ['documents', 'Documents', 'Files'],
  ['accounting', 'Accounting', 'Finance'],
  ['settings', 'Settings', 'Platform'],
];

export default function AdminRepositoryPage() {
  const [tenants, setTenants] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function load() {
      const result = await listAdminTenants();
      if (!active) {
        return;
      }

      if (!result.ok) {
        setError(result.message);
        setIsLoading(false);
        return;
      }

      setTenants(result.data.tenants.filter((tenant) => !tenant.isPlatformRoot));
      setError('');
      setIsLoading(false);
    }

    load();

    return () => {
      active = false;
    };
  }, []);

  const repositoryItems = useMemo(
    () =>
      MODULES.map(([key, label, category]) => ({
        key,
        label,
        category,
        tenantCount: tenants.filter((tenant) => tenant.enabledModuleKeys.includes(key)).length,
      })),
    [tenants]
  );

  const moduleFilters = useModuleFilters({ schema: repositorySchema, rows: repositoryItems });
  const filteredRows = moduleFilters.filterRows(repositoryItems);

  return (
    <section className="control-plane-page">
      <header className="control-plane-topbar">
        <div>
          <div className="control-plane-topbar__title">Repository</div>
          <div className="control-plane-topbar__subtitle">
            Catalogo moduli CRM realmente supportati dal prodotto
          </div>
        </div>
      </header>
        <FilterBar model={moduleFilters} />


      <div className="control-plane-content">
        {isLoading ? <div className="control-plane-empty-state">Caricamento repository moduli...</div> : null}
        {!isLoading && error ? <div role="alert" className="control-plane-inline-error wt-inline-error">{error}</div> : null}
        {!isLoading && !error ? (
          <section className="control-plane-card">
            <div className="control-plane-card__header">
              <div>
                <div className="control-plane-card__title">Moduli CRM</div>
                <div className="control-plane-card__subtitle">
                  Conteggio tenant calcolato sui tenant reali abilitati.
                </div>
              </div>
            </div>
            <div className="control-plane-repository-list">
              {filteredRows.map((item) => (
                <article key={item.key} className="control-plane-repository-item">
                  <div className="control-plane-repository-item__top">
                    <div>
                      <div className="control-plane-repository-item__title">{item.label}</div>
                      <div className="control-plane-repository-item__meta">
                        {item.key} · {item.category}
                      </div>
                    </div>
                    <div className="control-plane-badge-row">
                      <span className="control-plane-badge is-info">{item.tenantCount} tenant</span>
                      <span className="control-plane-badge">{item.category}</span>
                    </div>
                  </div>
                  <div className="control-plane-repository-item__description">
                    Modulo reale disponibile nel catalogo piattaforma.
                  </div>
                </article>
              ))}
            </div>
          </section>
        ) : null}
      </div>
    </section>
  );
}
